import React from "react";
import { Route } from "react-router-dom";
import {
  VerifyPhone,
  ProfilePage,
} from "@zillout/shared-components";
import {
  AccountProfileMenu,
  AccountFeedbackForm,
  AccountFeedbackHistory,
} from "../components/AccountRouteWrapper";

export const authRoutes = (
  <>
    <Route path="/verify-phone" element={<VerifyPhone />} />
    <Route path="/verify-phone/:signinType" element={<VerifyPhone />} />
    <Route path="/account" element={<AccountProfileMenu />} />
    <Route path="/account/feedback" element={<AccountFeedbackForm />} />
    <Route path="/account/feedback-history" element={<AccountFeedbackHistory />} />
    <Route path="/profile" element={<ProfilePage />} />
  </>
);
